import { splitBalance, type Currency } from '@acs/shared';

/** Money in minor units → locale currency text. Always two decimals: these are
 *  amounts with tax, where "183,27 zł" must never read as "183 zł". */
export function formatMoney(minor: number, currency: Currency, tag: string): string {
  return new Intl.NumberFormat(tag, { style: 'currency', currency, minimumFractionDigits: 2 }).format(minor / 100);
}

/** Seconds → `{ minutes, seconds }`, non-negative (the shared split; debt
 *  reads as zero here). */
export function minSec(totalSeconds: number): { minutes: number; seconds: number } {
  const { minutes, seconds } = splitBalance(Math.floor(totalSeconds));
  return { minutes, seconds };
}

/** Major-unit text in an <input> → minor units, or null when not a number. */
export function parseMoneyInput(text: string): number | null {
  const cleaned = text.replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d{0,2})?$/.test(cleaned)) return null;
  return Math.round(Number(cleaned) * 100);
}

/** Minor units → the plain number an <input> shows ("400.00" → "400"). */
export function moneyInputValue(minor: number | null): string {
  if (minor === null) return '';
  return minor % 100 === 0 ? String(minor / 100) : (minor / 100).toFixed(2);
}
